import React from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import db from "../../../db/index.json";
import { ArrowRight } from "lucide-react";
import NoData from "../../reusebale/noData";

const Landlord = ({
  onShowLandlordApproval,
  allPendingLandlord,
  handleLandlordTable,
}) => {
  const { rightPanel } = db;

  console.log("allPendingLandlord", allPendingLandlord);

  return (
    <div className="bg-white rounded-2xl py-5 px-4 w-full mt-5 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="flex justify-between items-center ">
        <ParagraphTag
          content={rightPanel.payments}
          classes="text-darkColor font-popinsSemiBold text-base"
        />
      </div>
      <div className="flex border-b-[1px] border-darkColor/40 pb-1 mt-6">
        <div className="w-[45%]">
          <ParagraphTag
            content={rightPanel.landlords}
            classes="text-darkColor/40 font-popinsMedium text-xs"
          />
        </div>
        <div className="w-[35%] text-center">
          <ParagraphTag
            content={"Company"}
            classes="text-darkColor/40 font-popinsMedium text-xs"
          />
        </div>
        <div className="w-[20%] text-end">
          <ParagraphTag
            content={rightPanel.quick}
            classes="text-darkColor/40 font-popinsMedium text-xs"
          />
        </div>
      </div>
      {allPendingLandlord?.map((item) => {
        return (
          <div className="flex mt-2 justify-between">
            <div className="w-[45%] flex items-center">
              <div className="w-[25%] 2xl:w-[20%] flex justify-center">
                <ImageTag
                  path={
                    item?.personalInformation?.profileImage?.url ||
                    "/assets/daashboard/landlord-color.png"
                  }
                  classes="w-[45px] h-[45px] object-cover rounded-full"
                  altText="login"
                />
              </div>
              <div className="w-[75%] 2xl:w-[80%] pl-3">
                <ParagraphTag
                  content={item?.personalInformation?.email}
                  classes="text-darkColor/40 font-popinsMedium text-xs"
                />
                <ParagraphTag
                  content={`${item?.personalInformation?.firstName}  ${item?.personalInformation?.lastName}`}
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
              </div>
            </div>
            <div className="w-[35%] flex flex-col items-center justify-center">
              <ParagraphTag
                content={`PROF-${item?._id?.slice(0, 7)}`}
                classes="text-darkColor/40 font-popinsMedium text-sm"
              />
              <ParagraphTag
                content={item?.companyInformation?.companyName}
                classes="text-darkColor font-popinsMedium text-sm"
              />
            </div>
            <div className="w-[20%] flex justify-end items-center pr-5">
              <div
                onC
                className="flex justify-center items-center bg-themeColor w-[35%] h-8 rounded-lg cursor-pointer"
                onClick={() => {
                  onShowLandlordApproval(item);
                }}
              >
                <ArrowRight color="#FFFFFF" size={20} strokeWidth={2} />
              </div>
            </div>
          </div>
        );
      })}
      {allPendingLandlord.length === 0 && (
        <div className="flex justify-center w-full">
          <NoData />
        </div>
      )}
    </div>
  );
};

export default Landlord;
